import { render, staticRenderFns } from "./ConfigOrder.vue?vue&type=template&id=0cd47cb4&scoped=true&"
import script from "./ConfigOrder.vue?vue&type=script&lang=js&"
export * from "./ConfigOrder.vue?vue&type=script&lang=js&"
import style0 from "./ConfigOrder.vue?vue&type=style&index=0&id=0cd47cb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd47cb4",
  null
  
)

export default component.exports